import {connect} from 'react-redux';
import AvailabilityTableComponent from '../components/AvailabilityTableComponent';
import AvailabilityTableMobileComponent from '../components/mobile/AvailabilityTableMobileComponent';

const mapStateToProps = state => {
  return {
    displayNoOfNights: state.availabilityReducer.displayNoOfNights,
    showRate: state.availabilityReducer.showRate,
    customer: state.availabilityReducer.customer
  }
};

const AvailabilityTable = connect(mapStateToProps, null)(AvailabilityTableComponent);
export const AvailabilityTableMobile = connect(mapStateToProps, null)(AvailabilityTableMobileComponent);

export default AvailabilityTable;


// WEBPACK FOOTER //
// ./src/containers/AvailabilityTable.js